module.exports = __webpack_public_path__ + "static/assets/bbc26599a8933f8339385ca9ab921269.png";